import { useAppContext } from "../../context/AppContext";

export default function GreetUser() {
  const { user, userLoading } = useAppContext();

  return userLoading ? (
    <section className="hidden lg:block animate-pulse space-y-3">
      <div className="h-5 w-[150px] bg-slate-300 rounded"></div>

      <div className="h-2 w-[100px] bg-slate-300 rounded"></div>
    </section>
  ) : (
    <section className="hidden lg:block">
      <h1 className="font-medium text-lg text-gray-800">
        Welcome {user?.first_name} 👋
      </h1>
      <p className="text-gray-400 text-sm">Here is Your Latest Updates</p>
    </section>
  );
}
